angular.module('impactx.basket').controller('DemandDispatchDialogCtrl',  ['$mdDialog', '$scope', 'data', 'trns', DemandDispatchDialogCtrl]);

function DemandDispatchDialogCtrl($mdDialog, $scope, data, trns)
{
    $scope.data = data;
    $scope.trns = trns;

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.accept = function ()
    {
        $mdDialog.hide();
    };

}